<template>
    <az-container>
        <az-form>
            <v-dialog :value="renderizar" persistent max-width="800" non-linear>
                <v-card>
                    <v-card-title class="title primary white--text thin" primary-title>
                        <span v-if="!statusFornecedor">Fornecedor não homologado</span>
                        <span v-if="statusFornecedor && quantidadePlanos == 0">Fornecedor não possui plano</span>
                        <span v-if="statusFornecedor && planoExpirado">Fornecedor com plano vencido</span>
                        <span v-if="statusFornecedor && planoPendente">Fornecedor com plano pendente</span>
                        <v-btn icon color @click.native="fechar" dark>
                            <v-icon>close</v-icon>
                        </v-btn>
                    </v-card-title>
                    <v-card-text class="text--primary">

                        <div v-if="!statusFornecedor">
                            <p class="dialog-text">
                                <span>Senhor(a) Fornecedor(a), sua empresa ainda não foi homologada.</span>
                            </p>
                            <p class="dialog-text">
                                <span>Por favor, entre em contato com o suporte: cadastro@comprasbr.com.br. </span>
                                <span>Caso já tenha enviado toda a documentação, aguarde que nossa equipe entrará em contato. </span>
                            </p>
                        </div>

                        <div v-if="statusFornecedor && quantidadePlanos == 0">
                            <p class="dialog-text">
                                <span>Senhor(a) Fornecedor(a), você ainda não possui um plano ativo. </span>
                            </p>
                            <p class="dialog-text">
                                <span>Por favor, escolha um plano para continuar laçando propostas, clique no link abaixo:</span>
                            </p>
                        </div>

                        <div v-if="statusFornecedor && planoExpirado">
                            <p class="dialog-text">
                                <span>Senhor(a) Fornecedor(a), seu plano venceu em {{planoExpirado.dataLimite | azDate('DD/MM/YYYY')}}. </span>
                            </p>
                            <p class="dialog-text">
                                <span>Por favor, realize a renovação para continuar laçando propostas, escolhendo um dos planos após clicar no link abaixo:</span>
                            </p>
                        </div>

                        <div v-if="statusFornecedor && planoPendente">
                            <p class="dialog-text">
                                <span>Senhor(a) Fornecedor(a), seu plano está pendente de pagamento.</span>
                            </p>
                            <p class="dialog-text">
                                <span>Por favor, realize o pagamento do seu plano para continuar laçando propostas, caso já tenha realizado o pagamento aguarde.</span>
                            </p>
                        </div>

                        <div  class="container-escolher-plano" v-if="statusFornecedor">
                            <router-link :to="{ name: 'planos'}" target="_blank">
                                Visualizar Planos
                            </router-link>
                        </div>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer/>
                        <v-btn color="primary" @click="fechar" class="btn-finalizar">OK</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </az-form>
    </az-container>
</template>

<script>

    export default {
        name: 'PlanoAssinatura',
        props: {
            quantidadePlanos: Number,
            planoExpirado: {
                type: Object
            },
            planoPendente: {
                type: Object
            },
            renderizar: {
                type: Boolean,
                default: false
            },
            statusFornecedor: Boolean
        },
        methods: {
            fechar() {
                this.$emit('fechar')
            }
        }
    }
</script>

<style scoped lang="stylus">

    .thin
        height: 55px
        justify-content: space-between;
        align-content: center;

    .container-escolher-plano
        width 100%
        text-align center

</style>
